import * as React from "react";

import * as moment from "moment";

import { Hour } from "./Hour";
import { Appointment, Direction, TimePeriod } from "./models";

interface Props {
    date: moment.Moment;
    entityId?: string;
    hourSize: number;
    timeDirection: Direction;
    appointments?: Appointment[];
    workingDay?: boolean;
    workingDayStartTime?: string;
    workingDayEndTime?: string;
    highlight?: TimePeriod;
    onAppointmentClick?: (appointment: Appointment) => void;
    onAppointmentDrop?: (itemId: string, appointment: Appointment) => void;
    onHourDrop?: (itemId: string, hour: moment.Moment, entityId: string) => void;
    onHourClick?: (hour: moment.Moment, entityId: string) => void;
}

export class Day extends React.Component<Props> {
    public render() {
        const { date, entityId } = this.props;
        const hours: moment.Moment[] = [];
        while (hours.length < 24) {
            hours.push(date.clone().add(hours.length, "hours"));
        }

        return (
            <div className="day">
                {this.renderHighlight()}
                {hours.map(hour => {
                    const appointmentsInHour = this.props.appointments && this.props.appointments.filter(appointment =>
                        appointment.start.isSameOrAfter(hour) && appointment.start.isBefore(hour.clone().endOf("hour")));

                    return (
                        <Hour
                            entityId={entityId}
                            time={hour}
                            hourSize={this.props.hourSize}
                            timeDirection={this.props.timeDirection}
                            key={hour.valueOf()}
                            appointments={appointmentsInHour}
                            workingDayStartTime={this.props.workingDay ? this.props.workingDayStartTime : "24:00"}
                            workingDayEndTime={this.props.workingDay ? this.props.workingDayEndTime : "00:00"}
                            onAppointmentClick={this.props.onAppointmentClick}
                            onAppointmentDrop={this.props.onAppointmentDrop}
                            onDrop={this.props.onHourDrop}
                            onClick={this.props.onHourClick}
                        />
                    );
                })}
            </div>
        );
    }

    private renderHighlight() {
        const { highlight, hourSize, date } = this.props;
        if (!highlight || !highlight.start.isBetween(date, date.clone().endOf("day"))) {
            return null;
        }

        const periodInHours = highlight.end.diff(highlight.start, "hours", true);
        const width = periodInHours * hourSize;
        const left = highlight.start.diff(date, "hours", true) * hourSize;

        /* eslint-disable-next-line react/forbid-dom-props */
        return <div className="highlight" style={{ left, width }} />;
    }
}
